var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.5,
    fill: "#DA4848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5443 12.5666H11.2943C11.2943 12.1524 10.9585 11.8166 10.5443 11.8166V12.5666ZM10.5443 12.6555L10.5441 13.4055C10.743 13.4056 10.9338 13.3266 11.0745 13.1859C11.2152 13.0453 11.2943 12.8545 11.2943 12.6555H10.5443ZM10.4557 12.6555H9.70573C9.70573 13.0696 10.0414 13.4054 10.4555 13.4055L10.4557 12.6555ZM10.4557 12.5666V11.8166C10.0415 11.8166 9.70573 12.1524 9.70573 12.5666H10.4557ZM11.25 6.3444C11.25 5.93019 10.9142 5.5944 10.5 5.5944C10.0858 5.5944 9.75 5.93019 9.75 6.3444H11.25ZM9.75 9.89996C9.75 10.3142 10.0858 10.65 10.5 10.65C10.9142 10.65 11.25 10.3142 11.25 9.89996H9.75ZM10.5 16.75C6.49594 16.75 3.25 13.5041 3.25 9.5H1.75C1.75 14.3325 5.66751 18.25 10.5 18.25V16.75ZM3.25 9.5C3.25 5.49594 6.49594 2.25 10.5 2.25V0.75C5.66751 0.75 1.75 4.66751 1.75 9.5H3.25ZM10.5 2.25C14.5041 2.25 17.75 5.49594 17.75 9.5H19.25C19.25 4.66751 15.3325 0.75 10.5 0.75V2.25ZM17.75 9.5C17.75 13.5041 14.5041 16.75 10.5 16.75V18.25C15.3325 18.25 19.25 14.3325 19.25 9.5H17.75ZM9.79427 12.5666V12.6555H11.2943V12.5666H9.79427ZM10.5445 11.9055L10.4559 11.9055L10.4555 13.4055L10.5441 13.4055L10.5445 11.9055ZM11.2057 12.6555V12.5666H9.70573V12.6555H11.2057ZM10.4557 13.3166H10.5443V11.8166H10.4557V13.3166ZM9.75 6.3444V9.89996H11.25V6.3444H9.75Z",
    fill: "#F4F5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5c5b04cfac8476a7c223947db995c44a.svg";
export { ForwardRef as ReactComponent };